import React from "react";
import "./style.css";
import Lottie from "react-lottie";
import animationData from "../../../../../static/json/questionnaire/weight-loss/LoseWeightFaster.json";

export const PcLoseWeightFaster = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
  return (
    <div className="lose-weight-faster-pc" data-model-id="16867:7332">

      <div className="contents">

        <div className="container">
          <div className="image-container">

            <Lottie
                options={{
                  loop: false,
                  autoplay: false,
                  animationData: animationData,
                  rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                  }
                }}
                height={400}
                width={335}
                isPaused={!isCurPage} />
          </div>

          <div className="text-container">
            <p className="p">
              <span className="text-wrapper">Lose </span>

              <span className="span">2X</span>

              <span className="text-wrapper">
                {" "}
                much weight with Calo vs. trying on your own
              </span>
            </p>

            <p className="subtitle">
              Calo&#39;s science-based approach helps you achieve lasting weight
              loss that fits your lifestyle.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};
